<template>
  <div class="store-table__layout" ref="storeTableLayout">
    <div
      class="store-table"
      v-bind:class="{
      'store-table--discount': showDiscountLabel
      }"
    >
      <table>
        <thead>
          <tr>
            <th class="store-table__image" v-if="!hideImage"></th>

            <th class="store-table__cart store-table__name">
              <template>{{ translations.addToCart }}</template>
            </th>

            <th>
              {{ translations.productSKU }}
            </th>

            <th v-for="key in displayedProductsAttributes" :key="key" :data-column="key">
              {{ getAttributeTaxonomyLabel(key) }}
            </th>

            <th v-if="!isRentCategory">
              {{ translations.status }}
            </th>

            <th data-html2canvas-ignore>
              {{ translations.quantity }}
            </th>

            <th class="store-table__price" v-bind:class="{ 'store-table__price--discount': showDiscountLabel }">
              {{ translations.productPrice }}
              {{ getVatStatusTranslation() }}
            </th>

            <th data-html2canvas-ignore></th>
            <th class="store-table__wishlist" v-if="displayWishlist" data-html2canvas-ignore></th>
          </tr>
        </thead>

        <SimpleRow v-for="product in displayedProducts"
          :product="product"
          :displayedAttributeTaxonomies="displayedProductsAttributes"
          :showDiscountLabel="showDiscountLabel"
          :key="`${prefix}${product.id}`"
          :showOtherInfo="showOtherInfo"
          :hideImage="hideImage"
          :hideName="hideName"
          :hideSKU="hideSKU"
          :priceLabel="getPriceLabel"
        />

      </table>
    </div>
  </div>
</template>


<script>
import SimpleRow from './SimpleRow.vue';

export default {
  name: 'ProductTable',
  components: {
    SimpleRow
  },
  props: {
    prefix: {
      type: String,
      default() {
        return '';
      },
    },
    displayedProducts: {
      type: Array,
      default() {
        return [];
      },
    },
    hideImage: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideName: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hideSKU: {
      type: Boolean,
      default() {
        return ws_vue_store.archive_product_sku === '0';
      },
    },
    displayWishlist: {
      type: Boolean,
      default() {
        return ws_vue_store.display_wishlist === "1";
      },
    },
  },
  data() {
    return {
      translations: {
        productName: ws_vue_store.translations.product_name,
        productSKU: ws_vue_store.translations.product_SKU,
        productPrice: ws_vue_store.translations.product_price,
        productResale: ws_vue_store.translations.product_resale,
        productDiscount: ws_vue_store.translations.product_discount,
        other: ws_vue_store.translations.other,
        withVat: ws_vue_store.translations.included_vat,
        withoutVat: ws_vue_store.translations.excluded_vat,
        addToCart: ws_vue_store.translations.add_to_cart_heading,
        packageChoice: ws_vue_store.translations.package_choice,
        rentDay: ws_vue_store.translations.day,
        noProductsMatch: ws_vue_store.translations.no_products_match,
        status: ws_vue_store.translations.status,
        quantity: ws_vue_store.translations.quantity,
      },
      isLoggedIn: Boolean(ws_vue_store.logged_in),
      allowedAttributes: this.$store.getters.getAllowedAttributes,
    };
  }, // data
  created() {}, // created
  computed: {
    showDiscountLabel() {
      for (const product of this.displayedProducts) {
        if (product.sale_price) return true;
        if (product.is_variable) {
          for (const variation of product.variations) {
            if (variation.sale_price) return true;
          }
        }
      }
      return false;
    },
    isRentCategory() {
      return this.$store.getters.getIsRentCategory;
    },
    isDiscountLabel() {
      return ws_vue_store.logged_in === '';
    },
    showPackageColumn() {
      for (const product of this.displayedProducts) {
        try {
          let data = JSON.parse(product.packages);
          if (data.length && data.length > 1) {
            return true;
          }
        } catch {}
        for (const variation of product.variations) {
          try {
            let data = JSON.parse(variation.packages);
            if (data.length && data.length > 1) {
              return true;
            }
          } catch {}
        }
      }

      return false;
    },
    displayedProductsAttributes() {
      if (this.displayedProducts.length === 0 || this.displayedProducts == undefined) {
        return [];
      }

      let currentAttributes = this.allowedAttributes ? this.allowedAttributes.slice(0) : [];

      let brandIndex = currentAttributes.findIndex((e) => e == 'pa_brand');

      // Move 'pa_brand' column to the end and add non attribute "sku" column
      if (brandIndex > -1) {
        currentAttributes.splice(brandIndex, 1);
        currentAttributes.push('pa_brand');
      }

      // if (this.showPackageColumn) {
      //   currentAttributes.unshift('package_sizes');
      // }

      return currentAttributes;
    },
    showOtherInfo() {
      if (this.displayedProducts.length === 0) {
        return false;
      }

      return this.displayedProducts.some(product => 
        !product.is_variable
          ? product.excerpt.length
          : product.excerpt.length
      );
    },
    includingTax() {
      return this.$store.getters.getTaxesEnabled;
    },
    getPriceLabel() {
      if (this.isRentCategory) {
        return `${this.translations.productPrice} / ${this.translations.rentDay}`;
      }
      return this.translations.productPrice;
    }
  }, // computed
  watch: {}, // watch
  methods: {
    getVatStatusTranslation() {
      if (this.includingTax) {
        return this.translations.withVat;
      } else {
        return this.translations.withoutVat;
      }
    },
    getProductPackages() {
      if (this.variation.packages) {
        try {
          return JSON.parse(this.variation.packages);
        } catch {}
      }
      return [];
    },
    getSelectedPackage() {
      if ( ! this.packages.length) return '';

      let selectedPackages = this.$store.getters.getSelectedPackages;
      return selectedPackages[this.variation.id] ? selectedPackages[this.variation.id] : '';
    },
    getAttributeTaxonomyLabel(taxonomyName) {
      const taxonomy = this.$store.getters.getAttributeTaxonomy(taxonomyName);
      if (taxonomy) {
        return taxonomy.label;
      }
      return '';
    },
    hasBrand() {
      return this.displayedProductsAttributes.includes('pa_brand');
    },
  }, // methods
};
</script>
